import React from "react";
import { getTranslations, isStarterLeague } from "../../../Common/utils";
import { useSelector } from "react-redux";
import LeagueLogo from "../../../ReusableComponents/Cloudinary/LeagueLogo";
import LeagueTypeIcon from "../../../ReusableComponents/Cloudinary/LeagueTypeIcon";

const LeagueBody = () => {
  const leagueState = useSelector((state) => state.league);
  const { selectedLeague } = leagueState;

  return (
    <div className="si-league__popup-wrap">
      <div className="si-league__popup-wrap-info">
        {isStarterLeague(selectedLeague?.league_type) ? (
          <LeagueLogo
            leagueType={selectedLeague?.league_type}
            leagueId={selectedLeague?.league_id}
            isGlobal
          />
        ) : (
          <LeagueTypeIcon type={selectedLeague?.league_type} />
        )}
        <span>{decodeURIComponent(selectedLeague?.league_name) || ""}</span>
      </div>
      <div className="si-league__popup-wrap-count">
        <i className="f1i-profile"></i>
        <span>
          {getTranslations("total_players", "Total Players:")}{" "}
          {selectedLeague?.member_count || 0}
        </span>
      </div>
    </div>
  );
};

export default LeagueBody;
